import classNames from 'classnames';
import React from 'react';
import { REPORTING_TABS } from './constants';

export interface ReportingTabsProps {
  activeTab: string;
  onChange: (tab: string) => void;
}

export const ReportingTabs: React.FC<ReportingTabsProps> = ({
  activeTab,
  onChange,
}) => (
  <div className='border-b border-gray-100 bg-white'>
    <style>{ `
      .reporting-tabs-scroll::-webkit-scrollbar { height: 0; }
      @media (max-width: 640px) {
        .reporting-tabs-scroll { scrollbar-width: none; }
        .reporting-tabs-scroll::-webkit-scrollbar { display: none; }
      }
    ` }</style>
    <div className='reporting-tabs-scroll flex min-w-max overflow-x-auto'>
      { REPORTING_TABS.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return (
          <button
              key={tab.id}
              type='button'
              onClick={() => onChange(tab.id)}
              className={classNames(
                'flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-3 text-sm font-medium transition-all duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1',
                isActive
                  ? 'border-emerald-500 bg-emerald-50/30 text-emerald-600'
                  : 'border-transparent text-gray-500 hover:bg-gray-50 hover:text-gray-800',
              )}
          >
            <Icon className='h-4 w-4' />
            { tab.label }
          </button>
        );
      }) }
    </div>
  </div>
);
